module.exports = __webpack_public_path__ + "img/small-4-mob.aa48299d.jpg";